import env from '@beam-australia/react-env';

export const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const isGoogleAnalyticsEnabled = env('GA_ENABLED') === 'true' || false;
